(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5405],{

/***/ 2211:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5444);
/* harmony import */ var _constants_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7579);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);




var devices = _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.devices */ .r.devices,
    fontSizes = _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontSizes */ .r.fontSizes,
    colors = _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors */ .r.colors,
    spaces = _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.spaces */ .r.spaces; // eslint-disable-next-line prettier/prettier, react/display-name

var StyledBullet = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Bullet__StyledBullet",
  componentId: "sc-1jzgohw-0"
})(["display:flex;align-items:start;margin-bottom:", "px;@media ", "{align-items:center;}"], spaces.medium, devices.tablet);
var StyledBulletIconContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Bullet__StyledBulletIconContainer",
  componentId: "sc-1jzgohw-1"
})(["margin-right:", "px;@media ", "{margin-right:", "px;svg{height:36px;}}"], spaces.regular, devices.tablet, spaces.smallX);
var StyledBulletText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Bullet__StyledBulletText",
  componentId: "sc-1jzgohw-2"
})(["flex-grow:1;font-family:'Aeonik';font-style:normal;font-size:", "px;font-weight:400;color:", ";width:504px;@media ", "{font-size:", "px;width:100%;}"], fontSizes.large8X, colors.gray[800], devices.tablet, fontSizes.large);

var Bullet = function Bullet(_ref) {
  var icon = _ref.icon,
      text = _ref.text;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledBullet, {
    children: [icon && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledBulletIconContainer, {
      children: icon
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledBulletText, {
      children: text
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Bullet);

/***/ }),

/***/ 8837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5444);
/* harmony import */ var _constants_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7579);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);




var devices = _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.devices */ .r.devices,
    fontSizes = _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontSizes */ .r.fontSizes,
    colors = _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors */ .r.colors,
    spaces = _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.spaces */ .r.spaces; // eslint-disable-next-line prettier/prettier, react/display-name

var StyledStep = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Step__StyledStep",
  componentId: "sc-1bvcgel-0"
})(["display:inline-flex;flex-direction:column;align-items:center;padding:", "px ", "px;background:linear-gradient( 180deg,", " 0%,rgba(255,255,255,0) 100% );border-radius:30px;flex:none;order:0;align-self:stretch;flex-grow:1;width:100%;height:100%;@media ", "{padding-top:", "px;padding-bottom:", "px;padding-left:", "px;padding-right:", "px;}"], spaces.large7X - 2, spaces.large2X - 2, colors.blue[50], devices.tablet, spaces.large2X, spaces.large2X, spaces.large, spaces.large);
var StyledStepIconContainer = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Step__StyledStepIconContainer",
  componentId: "sc-1bvcgel-1"
})(["margin-top:", "px;margin-bottom:", "px;margin-left:", "px;margin-right:", "px;svg{height:180px;width:180px;}img{min-height:180px;}@media ", "{margin-left:auto;margin-right:auto;}"], spaces.large2X - 2, spaces.large2X - 2, spaces.large10X, spaces.large10X, devices.tablet);
var StyledTop = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Step__StyledTop",
  componentId: "sc-1bvcgel-2"
})(["font-family:'Aeonik';font-style:normal;font-weight:500;font-size:", "px;line-height:130%;text-align:center;color:", ";flex:none;order:0;align-self:stretch;flex-grow:0;"], fontSizes.regular, colors.blue[600]);
var StyledBottom = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "Step__StyledBottom",
  componentId: "sc-1bvcgel-3"
})(["flex-grow:1;.header{font-family:'Aeonik';font-style:normal;font-weight:500;font-size:", "px;line-height:150%;text-align:center;color:", ";flex:none;order:0;align-self:stretch;flex-grow:0;}.description{font-family:'Aeonik';font-style:normal;font-weight:400;font-size:", "px;line-height:150%;text-align:center;color:", ";flex:none;order:1;align-self:stretch;flex-grow:0;}"], fontSizes.large2X, colors.gray[800], fontSizes.large, colors.gray[700]);

var Step = function Step(_ref) {
  var imgSrc = _ref.imgSrc,
      top = _ref.top,
      bottom = _ref.bottom;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledStep, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTop, {
      children: top
    }), imgSrc && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledStepIconContainer, {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("picture", {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("source", {
          srcSet: imgSrc,
          type: "image/png"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
          src: imgSrc,
          alt: "Banner image"
        })]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledBottom, {
      children: bottom
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Step);

/***/ }),

/***/ 1506:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_innova_labs_developers_trademark_trademark_frontend_v2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var _builds_innova_labs_developers_trademark_trademark_frontend_v2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5444);
/* harmony import */ var _constants_theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7579);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5893);


var _excluded = ["hideImageMobile"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_builds_innova_labs_developers_trademark_trademark_frontend_v2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var colors = _constants_theme__WEBPACK_IMPORTED_MODULE_2__/* .theme.colors */ .r.colors,
    devices = _constants_theme__WEBPACK_IMPORTED_MODULE_2__/* .theme.devices */ .r.devices,
    fontSizes = _constants_theme__WEBPACK_IMPORTED_MODULE_2__/* .theme.fontSizes */ .r.fontSizes,
    spaces = _constants_theme__WEBPACK_IMPORTED_MODULE_2__/* .theme.spaces */ .r.spaces;
var StyledWrapperBannerContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "MainBannerSection__StyledWrapperBannerContainer",
  componentId: "sc-1sd3chd-0"
})(["position:relative;width:100%;display:flex;flex-direction:column;align-items:center;&::before{content:'';display:block;position:absolute;left:0;right:0;top:0;bottom:0;background:", ";border-bottom-left-radius:100px;border-bottom-right-radius:100px;z-index:-1;}@media ", "{padding-left:", "px;padding-right:", "px;&::before{border-bottom-left-radius:50px;border-bottom-right-radius:50px;}}@media ", "{position:unset;width:auto;display:block;&::before{display:none;}}"], colors.blue[50], devices.laptopM, spaces.large2X, spaces.large2X, devices.tablet);
var StyledBannerContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "MainBannerSection__StyledBannerContainer",
  componentId: "sc-1sd3chd-1"
})(["display:flex;position:relative;flex-direction:column;width:100%;max-width:", "px;padding-top:", "px;padding-bottom:", "px;@media ", "{padding-left:", "px;padding-right:", "px;padding-top:", "px;padding-bottom:", "px;&::before{content:'';display:block;position:absolute;left:0;right:0;top:0;bottom:0;background:", ";border-bottom-left-radius:32px;border-bottom-right-radius:32px;z-index:-1;}}"], spaces.large24X * 10 + 80, spaces.large2X, spaces.large4X + 2, devices.tablet, spaces.regular, spaces.regular, spaces.regular, spaces.regular, colors.blue[50]);
var StyledTopBannerContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "MainBannerSection__StyledTopBannerContainer",
  componentId: "sc-1sd3chd-2"
})(["display:flex;justify-content:space-between;position:relative;"]);
var StyledBannerImageContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "MainBannerSection__StyledBannerImageContainer",
  componentId: "sc-1sd3chd-3"
})(["", " @media ", "{display:none;}"], function (_ref) {
  var width = _ref.width;
  return width && (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(["width:", "px;"], width);
}, devices.tablet); // eslint-disable-next-line prettier/prettier, react/display-name

var StyledMobileBannerImageContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)( /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref2, ref) {
  var hideImageMobile = _ref2.hideImageMobile,
      props = (0,_builds_innova_labs_developers_trademark_trademark_frontend_v2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_ref2, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", _objectSpread({
    ref: ref
  }, props));
})).withConfig({
  displayName: "MainBannerSection__StyledMobileBannerImageContainer",
  componentId: "sc-1sd3chd-4"
})(["display:none;img{width:64%;}@media ", "{display:block;text-align:center;margin-bottom:", "px;", "}"], devices.tablet, spaces.regular, function (_ref3) {
  var hideImageMobile = _ref3.hideImageMobile;
  return hideImageMobile && (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(["display:none;"]);
});
var StyledBannerContentContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "MainBannerSection__StyledBannerContentContainer",
  componentId: "sc-1sd3chd-5"
})(["display:flex;flex-direction:column;justify-content:center;@media ", "{width:100%;}"], devices.tablet);
var StyledBannerTopSection = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "MainBannerSection__StyledBannerTopSection",
  componentId: "sc-1sd3chd-6"
})(["margin-bottom:", "px;font-family:'Aeonik';font-style:normal;font-size:", "px;font-weight:400;color:", ";a{color:", ";}@media ", "{font-size:", "px;}"], spaces.regular, fontSizes.large, colors.gray[700], colors.blue[500], devices.tablet, fontSizes.regular);
var StyledBottomContainer = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "MainBannerSection__StyledBottomContainer",
  componentId: "sc-1sd3chd-7"
})(["display:flex;justify-content:flex-start;flex-wrap:wrap;.childrenDescription{width:228px;}@media ", "{.childrenDescription{width:100%;text-align:center;font-size:", "px;}}"], devices.tablet, fontSizes.regular);
var StyledRecentryTrademarkContainerDesktop = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "MainBannerSection__StyledRecentryTrademarkContainerDesktop",
  componentId: "sc-1sd3chd-8"
})(["@media ", "{display:none;}"], devices.tablet);
var StyledRecentryTrademarkContainerMobile = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "MainBannerSection__StyledRecentryTrademarkContainerMobile",
  componentId: "sc-1sd3chd-9"
})(["display:none;@media ", "{padding-left:", "px;padding-right:", "px;padding-top:", "px;padding-bottom:", "px;display:flex;}"], devices.tablet, spaces.regular, spaces.regular, spaces.regular, spaces.regular);

var MainBannerSection = function MainBannerSection(_ref4) {
  var imgSrc = _ref4.imgSrc,
      topSection = _ref4.topSection,
      bottomSection = _ref4.bottomSection,
      recentlyTrademarked = _ref4.recentlyTrademarked,
      hideImageMobile = _ref4.hideImageMobile;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(StyledWrapperBannerContainer, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(StyledBannerContainer, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(StyledTopBannerContainer, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(StyledBannerContentContainer, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledBannerTopSection, {
            children: topSection
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledMobileBannerImageContainer, {
            width: !bottomSection ? 270 : undefined,
            hideImageMobile: hideImageMobile,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("picture", {
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("source", {
                srcSet: imgSrc,
                type: "image/png"
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("img", {
                src: imgSrc,
                alt: "Banner image"
              })]
            })
          }), bottomSection && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledBottomContainer, {
            children: bottomSection
          })]
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledBannerImageContainer, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("picture", {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("source", {
              srcSet: imgSrc,
              type: "image/png"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("img", {
              src: imgSrc,
              alt: "Banner image"
            })]
          })
        })]
      }), recentlyTrademarked && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledRecentryTrademarkContainerDesktop, {
        children: recentlyTrademarked
      })]
    }), recentlyTrademarked && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(StyledRecentryTrademarkContainerMobile, {
      children: recentlyTrademarked
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (MainBannerSection);

/***/ }),

/***/ 5119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_innova_labs_developers_trademark_trademark_frontend_v2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(6835);
/* harmony import */ var _constants_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7579);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5444);
/* harmony import */ var _components_atomic_Step__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8837);
/* harmony import */ var _components_atomic_Icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6668);
/* harmony import */ var _constants_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(934);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7294);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(719);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1082);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1911);
/* harmony import */ var _hooks__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5125);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5893);













var colors = _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors */ .r.colors,
    devices = _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.devices */ .r.devices,
    fontSizes = _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontSizes */ .r.fontSizes,
    spaces = _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.spaces */ .r.spaces;
swiper__WEBPACK_IMPORTED_MODULE_7__/* ["default"].use */ .ZP.use([swiper__WEBPACK_IMPORTED_MODULE_7__/* .Navigation */ .W_]);
var StyledThreeStepSection = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "ThreeStepSection__StyledThreeStepSection",
  componentId: "sc-1yhv8uz-0"
})(["max-width:", "px;width:100%;margin-top:", "px;display:flex;flex-direction:column;justify-content:center;.headerSection{font-family:'Aeonik';font-style:normal;font-weight:500;font-size:", "px;line-height:130%;text-align:center;color:", ";flex:none;order:0;align-self:stretch;flex-grow:0;}.subHeaderSection{font-family:'Aeonik';font-style:normal;font-weight:400;font-size:", "px;line-height:150%;margin-top:", "px;text-align:center;color:", ";flex:none;order:0;align-self:stretch;flex-grow:0;}.columnDesktopContainer{display:flex;margin-top:", "px;justify-content:center;gap:13px;}.columnMobileContainer{display:none;}@media ", "{margin-top:", "px;margin-bottom:", "px;margin-left:0;margin-right:0;display:flex;flex-direction:column;justify-content:center;align-items:center;gap:0px;flex:none;order:1;flex-grow:0;.headerSection{padding:0px ", "px;font-size:", "px;line-height:150%;}.subHeaderSection{padding:0px ", "px;font-size:", "px;line-height:150%;margin-top:", "px;margin-bottom:", "px;}.columnDesktopContainer{display:none;}.columnMobileContainer{display:block;width:100%;padding-left:", "px;padding-right:", "px;}.swiper-slide{width:90%;}}"], spaces.large24X * 10 + 80, spaces.large24X, fontSizes.large11X, colors.gray[800], fontSizes.large, spaces.medium, colors.gray[700], spaces.large7X - 2, devices.tablet, spaces.large9X, spaces.large9X, spaces.regular, fontSizes.large2X, spaces.regular, fontSizes.regular, spaces.smallX, spaces.large2X, spaces.regular, spaces.regular);
var StyledStep = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "ThreeStepSection__StyledStep",
  componentId: "sc-1yhv8uz-1"
})(["width:30%;img{width:180px;}.container{height:100%;.description{margin-top:", "px;}}@media ", "{img{width:", "px;}}@media ", "{width:initial;img{width:180px;}}"], spaces.small - 2, devices.laptopM, spaces.large24X, devices.tablet);
var StyledDivider = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "ThreeStepSection__StyledDivider",
  componentId: "sc-1yhv8uz-2"
})(["align-items:center;display:flex;"]);
var StyledSliderNavigation = styled_components__WEBPACK_IMPORTED_MODULE_10__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "ThreeStepSection__StyledSliderNavigation",
  componentId: "sc-1yhv8uz-3"
})(["align-items:center;display:flex;justify-content:center;gap:34px;padding-right:", "px;.navButton{cursor:pointer;}.swiper-button-disabled{cursor:initial;svg{path{fill:", ";}}}"], spaces.regular, colors.gray[500]);

var ThreeStepSection = function ThreeStepSection(_ref) {
  var title = _ref.title,
      subTitle = _ref.subTitle,
      steps = _ref.steps,
      elRef = _ref.elRef;

  var _useSwiperRef = (0,_hooks__WEBPACK_IMPORTED_MODULE_8__/* .useSwiperRef */ .S)(),
      _useSwiperRef2 = (0,_builds_innova_labs_developers_trademark_trademark_frontend_v2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_useSwiperRef, 2),
      nextEl = _useSwiperRef2[0],
      nextElRef = _useSwiperRef2[1];

  var _useSwiperRef3 = (0,_hooks__WEBPACK_IMPORTED_MODULE_8__/* .useSwiperRef */ .S)(),
      _useSwiperRef4 = (0,_builds_innova_labs_developers_trademark_trademark_frontend_v2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_useSwiperRef3, 2),
      prevEl = _useSwiperRef4[0],
      prevElRef = _useSwiperRef4[1];

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(StyledThreeStepSection, {
    ref: elRef,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
      className: "headerSection",
      children: title
    }), subTitle && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
      className: "subHeaderSection",
      children: subTitle
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
      className: "columnDesktopContainer",
      children: steps.map(function (step, idx) {
        var header = step.header,
            description = step.description,
            icon = step.icon;
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(react__WEBPACK_IMPORTED_MODULE_4__.Fragment, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(StyledStep, {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_components_atomic_Step__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
              top: "STEP 0".concat(idx + 1),
              bottom: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
                className: "container",
                children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
                  className: "header",
                  children: header
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
                  className: "description",
                  children: description
                })]
              }),
              imgSrc: icon
            })
          }), (steps === null || steps === void 0 ? void 0 : steps.length) !== idx + 1 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(StyledDivider, {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_components_atomic_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
              alias: _constants_icons__WEBPACK_IMPORTED_MODULE_3__/* .ICONS_ALIASES.arrowRight */ .F.arrowRight,
              color: _constants_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.blue[500] */ .r.colors.blue[500]
            })
          })]
        }, "step:".concat(idx));
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
      className: "columnMobileContainer",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_5__/* .Swiper */ .tq, {
        spaceBetween: 16,
        slidesPerView: 'auto',
        navigation: {
          prevEl: prevEl,
          nextEl: nextEl
        },
        children: [steps.map(function (step, idx) {
          var header = step.header,
              description = step.description,
              icon = step.icon;
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_5__/* .SwiperSlide */ .o5, {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(StyledStep, {
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_components_atomic_Step__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                top: "STEP 0".concat(idx + 1),
                bottom: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)("div", {
                  className: "container",
                  children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
                    className: "header",
                    children: header
                  }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
                    className: "description",
                    children: description
                  })]
                }),
                imgSrc: icon
              })
            })
          }, "step:".concat(idx));
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsxs)(StyledSliderNavigation, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
            ref: prevElRef,
            className: "navButton",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_components_atomic_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
              alias: _constants_icons__WEBPACK_IMPORTED_MODULE_3__/* .ICONS_ALIASES.arrowLeft */ .F.arrowLeft,
              color: colors.blue[500],
              height: 20,
              width: 20
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)("div", {
            ref: nextElRef,
            className: "navButton",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_9__.jsx)(_components_atomic_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
              alias: _constants_icons__WEBPACK_IMPORTED_MODULE_3__/* .ICONS_ALIASES.arrowRight */ .F.arrowRight,
              color: colors.blue[500],
              height: 20,
              width: 20
            })
          })]
        })]
      })
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (ThreeStepSection);

/***/ }),

/***/ 2238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ sections_TrustPilotSection; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(6835);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(5444);
// EXTERNAL MODULE: ./_constants/theme.js
var theme = __webpack_require__(7579);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(1752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./_components/atomic/TrustCard/index.jsx






var _getConfig = config_default()(),
    publicRuntimeConfig = _getConfig.publicRuntimeConfig;

var devices = theme/* theme.devices */.r.devices,
    fontSizes = theme/* theme.fontSizes */.r.fontSizes,
    colors = theme/* theme.colors */.r.colors,
    spaces = theme/* theme.spaces */.r.spaces; // eslint-disable-next-line prettier/prettier, react/display-name

var StyledTrustCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrustCard__StyledTrustCard",
  componentId: "sc-xqhkuu-0"
})(["height:100%;justify-content:space-between;display:inline-flex;flex-direction:column;align-items:flex-start;padding:", "px ", "px ", "px ", "px;background:linear-gradient( 180deg,", " 0%,rgba(249,250,251,0) 100% );border-radius:30px;flex:none;order:0;align-self:stretch;flex-grow:1;width:100%;@media ", "{padding:", "px;.headerSection{padding:0px ", "px;font-size:", "px;line-height:150%;}.subHeaderSection{padding:0px ", "px;font-size:", "px;line-height:150%;margin-top:", "px;margin-bottom:", "px;}}"], spaces.large2X - 2, spaces.medium, spaces.medium, spaces.large2X - 2, colors.gray[100], devices.tablet, spaces.medium, spaces.regular, fontSizes.large2X, spaces.regular, fontSizes.regular, spaces.smallX, spaces.large2X);
var StyledTrustDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrustCard__StyledTrustDescription",
  componentId: "sc-xqhkuu-1"
})(["margin-top:", "px;margin-bottom:", "px;font-family:'Aeonik';font-style:normal;font-weight:400;font-size:", "px;line-height:150%;color:", ";text-align:justify;align-self:stretch;@media ", "{font-size:", "px;text-align:left;}"], spaces.medium, spaces.medium, fontSizes.large, colors.gray[800], devices.tablet, fontSizes.regular);
var StyledTrustStarDescription = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrustCard__StyledTrustStarDescription",
  componentId: "sc-xqhkuu-2"
})(["text-align:left;@media ", "{text-align:center;}"], devices.tablet);
var StyledTrustAuthor = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrustCard__StyledTrustAuthor",
  componentId: "sc-xqhkuu-3"
})(["font-family:'Aeonik';font-style:normal;font-weight:400;font-size:", "px;line-height:150%;text-transform:uppercase;color:", ";@media ", "{text-align:center;}"], fontSizes.large, colors.gray[800], devices.tablet);
var StyledTrustCustomer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrustCard__StyledTrustCustomer",
  componentId: "sc-xqhkuu-4"
})(["font-family:'Aeonik';font-style:normal;font-weight:400;font-size:", "px;line-height:150%;color:", ";@media ", "{text-align:center;}"], fontSizes.regular, colors.gray[500], devices.tablet);

var TrustCard = function TrustCard(_ref) {
  var description = _ref.description,
      author = _ref.author;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledTrustCard, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledTrustStarDescription, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)("picture", {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("source", {
            srcSet: "".concat(publicRuntimeConfig.basePath, "/images/5-star.svg"),
            type: "image/png"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
            src: "".concat(publicRuntimeConfig.basePath, "/images/5-star.svg"),
            alt: ""
          })]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledTrustDescription, {
        children: description
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      style: {
        width: '100%'
      },
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledTrustAuthor, {
        children: author
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledTrustCustomer, {
        children: "Trademark Genius Customer"
      })]
    })]
  });
};

/* harmony default export */ var atomic_TrustCard = (TrustCard);
// EXTERNAL MODULE: ./_components/atomic/Icon/index.jsx + 49 modules
var Icon = __webpack_require__(6668);
// EXTERNAL MODULE: ./_constants/icons.js
var icons = __webpack_require__(934);
;// CONCATENATED MODULE: ./_constants/trustPilots.js
var trustPilots = [{
  author: 'Mark D.',
  description: 'Trademark Genius helped register my companies trademark. The process was simple, their customer service was excellent, and my trademark was registered without any issues. Highly recommend Trademark Genius.'
}, {
  author: 'Terry F.',
  description: 'Got my trademark registered with USPTO without any issues. Their dashboard is a great tool and helped me track the progress of my application all the way to completion. Will use them again for any other TM needs.'
}, {
  author: 'Lisa N.',
  description: 'My trademark registration was a unique situation that required some extra work, the team helped guide me through this daunting process and got my application submit to USPTO (and was approved without issues) Thanks TMG!'
}, {
  author: 'Kelly T.',
  description: 'I contacted Trademark Genius after running into many issues trying to register my companies trademark myself. They helped solve every issue i ran into. Would definitely recommend spending the money to have professionals handle this process.'
}, {
  author: 'Jacob J.',
  description: 'Submit my application, they reviewed it and identified some mistakes that would have caused a rejection. We fixed those and my trademark was approved. A+'
}, {
  author: 'Guy H.',
  description: 'Decided to use Trademark Genius to trademark my business name. The process was easy with no unexpected issues. I will be using them again for any future trademarking needs.'
}, {
  author: 'Esther H.',
  description: 'The staff here knows what they are doing, I used them to file 2 trademarks this year, both were approved by the USPTO. I would recommend them to anyone looking to file without issues.'
}];
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(719);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(1082);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(1911);
// EXTERNAL MODULE: ./_hooks/index.js + 2 modules
var _hooks = __webpack_require__(5125);
;// CONCATENATED MODULE: ./_components/composed/sections/TrustPilotSection/index.jsx
















var TrustPilotSection_getConfig = config_default()(),
    TrustPilotSection_publicRuntimeConfig = TrustPilotSection_getConfig.publicRuntimeConfig;

var TrustPilotSection_colors = theme/* theme.colors */.r.colors,
    TrustPilotSection_devices = theme/* theme.devices */.r.devices,
    TrustPilotSection_fontSizes = theme/* theme.fontSizes */.r.fontSizes,
    TrustPilotSection_spaces = theme/* theme.spaces */.r.spaces;
swiper_esm/* default.use */.ZP.use([swiper_esm/* Navigation */.W_]);
var StyledTrustPilotSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrustPilotSection__StyledTrustPilotSection",
  componentId: "sc-jnrgeg-0"
})(["max-width:", "px;display:flex;gap:30px;.swiper{display:flex;flex-direction:column;}.swiper-slide{width:31.5%;}@media ", "{padding-left:", "px;padding-right:", "px;}@media ", "{margin-left:", "px;margin-right:", "px;.swiper-slide{width:100%;}}"], TrustPilotSection_spaces.large24X * 10 + 80, TrustPilotSection_devices.laptopM, TrustPilotSection_spaces.large2X, TrustPilotSection_spaces.large2X, TrustPilotSection_devices.tablet, TrustPilotSection_spaces.regular, TrustPilotSection_spaces.regular);
var TrustPilotSection_StyledTrustCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrustPilotSection__StyledTrustCard",
  componentId: "sc-jnrgeg-1"
})(["height:100%;"]);
var StyledSliderNavigationButtons = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrustPilotSection__StyledSliderNavigationButtons",
  componentId: "sc-jnrgeg-2"
})(["height:100%;align-items:end;display:flex;justify-content:center;gap:", "px;.navButton{cursor:pointer;}.swiper-button-disabled{cursor:initial;svg{path{fill:", ";}}}@media ", "{padding-right:0px;svg{width:24px;}}"], TrustPilotSection_spaces.large2X, TrustPilotSection_colors.gray[500], TrustPilotSection_devices.tablet);
var StyledSliderNavigation = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrustPilotSection__StyledSliderNavigation",
  componentId: "sc-jnrgeg-3"
})(["align-items:flex-end;display:flex;justify-content:space-between;margin-top:", "px;margin-left:9%;margin-right:9%;@media ", "{flex-direction:column;align-items:center;gap:", "px;margin-top:", "px;margin-left:", "px;margin-right:", "px;}"], TrustPilotSection_spaces.large7X - 2, TrustPilotSection_devices.tablet, TrustPilotSection_spaces.large2X - 2, TrustPilotSection_spaces.large2X, TrustPilotSection_spaces.regular, TrustPilotSection_spaces.regular);
var StyledTrustLogoSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrustPilotSection__StyledTrustLogoSection",
  componentId: "sc-jnrgeg-4"
})(["flex-direction:column;.trustLogoReviews{font-family:'Aeonik';font-style:normal;font-weight:400;font-size:", "px;line-height:150%;color:", ";}@media ", "{align-items:center;display:flex;.trustLogoReviews{text-align:center;padding-left:", "px;padding-right:", "px;}}"], TrustPilotSection_fontSizes.regular, TrustPilotSection_colors.gray[500], TrustPilotSection_devices.tablet, TrustPilotSection_spaces.large2X - 2, TrustPilotSection_spaces.large2X - 2);
var StyledSectionWithHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TrustPilotSection__StyledSectionWithHeader",
  componentId: "sc-jnrgeg-5"
})(["margin-top:", "px;display:flex;flex-direction:column;.headerSection{font-family:'Aeonik';font-style:normal;font-weight:500;font-size:", "px;line-height:130%;text-align:center;color:", ";flex:none;order:0;align-self:stretch;flex-grow:0;margin-left:9%;margin-right:9%;}.subHeaderSection{font-family:'Aeonik';font-style:normal;font-weight:400;font-size:", "px;line-height:150%;margin-top:", "px;margin-bottom:", "px;text-align:center;color:", ";flex:none;order:0;align-self:stretch;flex-grow:0;margin-left:9%;margin-right:9%;}@media ", "{margin-top:", "px;margin-bottom:", "px;margin-left:0;margin-right:0;.headerSection{font-size:", "px;line-height:150%;margin-left:", "px;margin-right:", "px;}.subHeaderSection{margin-left:", "px;margin-right:", "px;font-size:", "px;line-height:150%;margin-top:", "px;margin-bottom:", "px;}}"], TrustPilotSection_spaces.large24X, TrustPilotSection_fontSizes.large11X, TrustPilotSection_colors.gray[800], TrustPilotSection_fontSizes.large, TrustPilotSection_spaces.medium, TrustPilotSection_spaces.large6X + 2, TrustPilotSection_colors.gray[700], TrustPilotSection_devices.tablet, TrustPilotSection_spaces.large9X, TrustPilotSection_spaces.large9X, TrustPilotSection_fontSizes.large2X, TrustPilotSection_spaces.regular, TrustPilotSection_spaces.regular, TrustPilotSection_spaces.regular, TrustPilotSection_spaces.regular, TrustPilotSection_fontSizes.regular, TrustPilotSection_spaces.smallX, TrustPilotSection_spaces.large2X);

var TrustPilotSection = function TrustPilotSection(_ref) {
  var title = _ref.title,
      subTitle = _ref.subTitle,
      elRef = _ref.elRef;

  var _useSwiperRef = (0,_hooks/* useSwiperRef */.S)(),
      _useSwiperRef2 = (0,slicedToArray/* default */.Z)(_useSwiperRef, 2),
      nextEl = _useSwiperRef2[0],
      nextElRef = _useSwiperRef2[1];

  var _useSwiperRef3 = (0,_hooks/* useSwiperRef */.S)(),
      _useSwiperRef4 = (0,slicedToArray/* default */.Z)(_useSwiperRef3, 2),
      prevEl = _useSwiperRef4[0],
      prevElRef = _useSwiperRef4[1];

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledSectionWithHeader, {
    ref: elRef,
    children: [title && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "headerSection",
      children: title
    }), subTitle && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "subHeaderSection",
      children: subTitle
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledTrustPilotSection, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
        spaceBetween: 32,
        slidesPerView: "auto",
        navigation: {
          prevEl: prevEl,
          nextEl: nextEl
        },
        children: trustPilots.map(function (trustPilot, idx) {
          var author = trustPilot.author,
              description = trustPilot.description;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(TrustPilotSection_StyledTrustCard, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(atomic_TrustCard, {
                author: author,
                description: description
              })
            })
          }, "step:".concat(idx));
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledSliderNavigation, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(StyledTrustLogoSection, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("picture", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("source", {
              srcSet: "".concat(TrustPilotSection_publicRuntimeConfig.basePath, "/images/trustpilot-logo.svg"),
              type: "image/png"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "".concat(TrustPilotSection_publicRuntimeConfig.basePath, "/images/trustpilot-logo.svg"),
              alt: ""
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          style: {
            marginTop: '14px',
            marginBottom: '5px'
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("picture", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("source", {
              srcSet: "".concat(TrustPilotSection_publicRuntimeConfig.basePath, "/images/5-star.svg"),
              type: "image/png"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: "".concat(TrustPilotSection_publicRuntimeConfig.basePath, "/images/5-star.svg"),
              alt: ""
            })]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "trustLogoReviews",
          children: "4.7 out of 5 based on 55012 reviews. Showing our 4 and 5 stars reviews."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledSliderNavigationButtons, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          ref: prevElRef,
          className: "navButton",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
            alias: icons/* ICONS_ALIASES.arrowLeft */.F.arrowLeft,
            color: TrustPilotSection_colors.blue[500],
            height: 30,
            width: 30
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          ref: nextElRef,
          className: "navButton",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
            alias: icons/* ICONS_ALIASES.arrowRight */.F.arrowRight,
            color: TrustPilotSection_colors.blue[500],
            height: 30,
            width: 30
          })
        })]
      })]
    })]
  });
};

/* harmony default export */ var sections_TrustPilotSection = (TrustPilotSection);

/***/ }),

/***/ 4235:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(5444);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(1752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ./_constants/theme.js
var theme = __webpack_require__(7579);
// EXTERNAL MODULE: ./_constants/icons.js
var icons = __webpack_require__(934);
// EXTERNAL MODULE: ./_constants/routes.js
var routes = __webpack_require__(672);
// EXTERNAL MODULE: ./_redux/search/slice.js
var slice = __webpack_require__(1853);
// EXTERNAL MODULE: ./_redux/search/selector.js
var selector = __webpack_require__(5781);
// EXTERNAL MODULE: ./_components/atomic/Button/index.jsx
var Button = __webpack_require__(8509);
// EXTERNAL MODULE: ./_components/atomic/Icon/index.jsx + 49 modules
var Icon = __webpack_require__(6668);
// EXTERNAL MODULE: ./_components/composed/sections/FAQSection/index.jsx
var FAQSection = __webpack_require__(3981);
// EXTERNAL MODULE: ./_components/composed/sections/MainBannerSection/index.jsx
var MainBannerSection = __webpack_require__(1506);
// EXTERNAL MODULE: ./_components/atomic/Bullet/index.jsx
var Bullet = __webpack_require__(2211);
// EXTERNAL MODULE: ./_components/atomic/DescriptionButton/index.jsx
var DescriptionButton = __webpack_require__(8191);
// EXTERNAL MODULE: ./_components/atomic/Input/index.jsx
var Input = __webpack_require__(554);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(719);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(1082);
// EXTERNAL MODULE: ./_config/index.js
var _config = __webpack_require__(8002);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./_components/composed/sections/HomeBannerSection/index.jsx




















var _getConfig = config_default()(),
    publicRuntimeConfig = _getConfig.publicRuntimeConfig;

var colors = theme/* theme.colors */.r.colors,
    devices = theme/* theme.devices */.r.devices,
    fontSizes = theme/* theme.fontSizes */.r.fontSizes,
    spaces = theme/* theme.spaces */.r.spaces;
var StyledHomeBannerSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "HomeBannerSection__StyledHomeBannerSection",
  componentId: "sc-1iirs7y-0"
})(["width:100%;.bottomSearchContainer{width:100%;}.bottomSearchContainer > div:first-child{margin-bottom:", "px;}@media ", "{.bottomSearchContainer > div:first-child{margin-bottom:", "px;}}"], spaces.large2X - 2, devices.tablet, spaces.regular);
var StyledRecentlyTrademarked = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "HomeBannerSection__StyledRecentlyTrademarked",
  componentId: "sc-1iirs7y-1"
})(["margin-top:50px;display:flex;flex-direction:row;@media ", "{flex-direction:column;width:100%;}"], devices.tablet);
var StyledRecentlyTrademarkedHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "HomeBannerSection__StyledRecentlyTrademarkedHeader",
  componentId: "sc-1iirs7y-2"
})(["font-family:'Aeonik';font-style:normal;font-weight:400;font-size:", "px;line-height:150%;color:", ";white-space:nowrap;margin-right:82px;display:flex;align-items:center;@media ", "{font-size:", "px;margin-right:0px;margin-bottom:", "px;justify-content:center;}"], fontSizes.large, colors.gray[800], devices.tablet, fontSizes.regular, spaces.regular);
var StyledRecentlyTrademarkedSwiper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "HomeBannerSection__StyledRecentlyTrademarkedSwiper",
  componentId: "sc-1iirs7y-3"
})(["display:contents;.swiper{margin-left:40px;margin-right:40px;display:flex;flex-direction:column;}.swiper-slide{width:17.3%;display:flex;align-items:center;}@media ", "{.swiper-slide{width:42%;}}"], devices.tablet);
var StyledRecentlyTrademarkedSwiperContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "HomeBannerSection__StyledRecentlyTrademarkedSwiperContainer",
  componentId: "sc-1iirs7y-4"
})(["display:flex;.navButton{cursor:pointer;}.swiper-button-disabled{cursor:initial;svg{path{fill:", ";}}}"], colors.gray[500]);
var StyledRecentlyTrademarkedSwiperNav = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "HomeBannerSection__StyledRecentlyTrademarkedSwiperNav",
  componentId: "sc-1iirs7y-5"
})(["display:flex;align-items:center;"]);
var StyledLogoCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "HomeBannerSection__StyledLogoCard",
  componentId: "sc-1iirs7y-6"
})([".logoImg{width:100%;max-height:50px;}"]);
var logoSwiper = [{
  imgSrc: "".concat(_config/* config.basePath */.v.basePath, "/images/logoswiper1.svg")
}, {
  imgSrc: "".concat(_config/* config.basePath */.v.basePath, "/images/logoswiper2.svg")
}, {
  imgSrc: "".concat(_config/* config.basePath */.v.basePath, "/images/logoswiper3.svg")
}, {
  imgSrc: "".concat(_config/* config.basePath */.v.basePath, "/images/logoswiper4.svg")
}, {
  imgSrc: "".concat(_config/* config.basePath */.v.basePath, "/images/logoswiper5.svg")
}];

var LogoSwiper = function LogoSwiper() {
  var swiperRef = react.useRef(null);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledRecentlyTrademarked, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledRecentlyTrademarkedHeader, {
      children: "Recently Trademarked:"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledRecentlyTrademarkedSwiperContainer, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(StyledRecentlyTrademarkedSwiperNav, {
        className: "navButton",
        onClick: function onClick() {
          return swiperRef.current.swiper.slidePrev();
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
          alias: icons/* ICONS_ALIASES.arrowSquareLeft */.F.arrowSquareLeft,
          color: colors.gray[800]
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledRecentlyTrademarkedSwiper, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
          loop: true,
          spaceBetween: 32,
          slidesPerView: "auto",
          ref: swiperRef,
          children: logoSwiper.map(function (logo, idx) {
            var imgSrc = logo.imgSrc;
            return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(StyledLogoCard, {
                children: /*#__PURE__*/(0,jsx_runtime.jsxs)("picture", {
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("source", {
                    srcSet: imgSrc,
                    type: "image/png"
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                    className: "logoImg",
                    src: imgSrc,
                    alt: ""
                  })]
                })
              })
            }, "step:".concat(idx));
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledRecentlyTrademarkedSwiperNav, {
        className: "navButton",
        onClick: function onClick() {
          return swiperRef.current.swiper.slideNext();
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
          alias: icons/* ICONS_ALIASES.arrowSquareRight */.F.arrowSquareRight,
          color: colors.gray[800]
        })
      })]
    })]
  });
};

var HomeBannerSection = function HomeBannerSection(_ref) {
  var search = _ref.search,
      setSearch = _ref.setSearch,
      setPage = _ref.setPage;
  var router = (0,next_router.useRouter)();
  var handleClick = (0,react.useCallback)(function (event) {
    event.preventDefault();
    setPage('1');
    router.push({
      pathname: routes/* ROUTES.search */.Z.search,
      query: {
        text: search
      }
    });
  }, [router, search, setPage]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledHomeBannerSection, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(MainBannerSection/* default */.Z, {
      imgSrc: "".concat(publicRuntimeConfig.basePath, "/images/home.svg"),
      recentlyTrademarked: /*#__PURE__*/(0,jsx_runtime.jsx)(LogoSwiper, {}),
      hideImageMobile: true,
      topSection: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Bullet/* default */.Z, {
          icon: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
            alias: icons/* ICONS_ALIASES.upload */.F.upload,
            color: theme/* theme.colors.blue.500 */.r.colors.blue[500]
          }),
          text: "File Your Trademark Online"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Bullet/* default */.Z, {
          icon: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
            alias: icons/* ICONS_ALIASES.lock */.F.lock,
            color: theme/* theme.colors.blue.500 */.r.colors.blue[500]
          }),
          text: "Official USPTO Registration process"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Bullet/* default */.Z, {
          icon: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
            alias: icons/* ICONS_ALIASES.shieldTick */.F.shieldTick,
            color: theme/* theme.colors.blue.500 */.r.colors.blue[500]
          }),
          text: "Protect Your Brand Today"
        })]
      }),
      bottomSection: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "bottomSearchContainer",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Input/* default */.Z, {
          borderColor: theme/* theme.colors.gray.200 */.r.colors.gray[200],
          textColor: theme/* theme.colors.gray.500 */.r.colors.gray[500],
          color: theme/* theme.colors.white */.r.colors.white,
          hoverColor: theme/* theme.colors.white */.r.colors.white,
          hoverTextColor: theme/* theme.colors.gray.500 */.r.colors.gray[500],
          placeholder: "Search trademark availability",
          value: search,
          onChange: function onChange(e) {
            return setSearch(e.target.value);
          },
          onKeyPress: function onKeyPress(event) {
            if (event.key === 'Enter') {
              handleClick(event);
            }
          },
          suffix: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            onClick: handleClick,
            color: theme/* theme.colors.orange.500 */.r.colors.orange[500],
            children: "Search"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(DescriptionButton/* default */.Z, {
          suffix: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
            onClick: function onClick() {
              return router_default().push(routes/* ROUTES.trademarkRegistration */.Z.trademarkRegistration);
            },
            suffix: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
              alias: icons/* ICONS_ALIASES.arrowRight */.F.arrowRight,
              color: theme/* theme.colors.orange.500 */.r.colors.orange[500]
            }),
            textColor: theme/* theme.colors.orange.500 */.r.colors.orange[500],
            color: theme/* theme.colors.orange.25 */.r.colors.orange[25],
            hoverColor: theme/* theme.colors.white */.r.colors.white,
            hoverTextColor: theme/* theme.colors.orange.500 */.r.colors.orange[500],
            large: true,
            children: "Start Registering Now"
          }),
          borderColor: theme/* theme.colors.orange.500 */.r.colors.orange[500],
          textColor: theme/* theme.colors.white */.r.colors.white,
          color: theme/* theme.colors.orange.500 */.r.colors.orange[500],
          mobileColumnMode: true,
          large: true,
          children: "Already know your Trademark is available?"
        })]
      })
    })
  });
};

/* harmony default export */ var sections_HomeBannerSection = (HomeBannerSection);
// EXTERNAL MODULE: ./_components/composed/sections/BottomBannerSection/index.jsx
var BottomBannerSection = __webpack_require__(2410);
// EXTERNAL MODULE: ./_components/composed/sections/ThreeStepSection/index.jsx
var ThreeStepSection = __webpack_require__(5119);
;// CONCATENATED MODULE: ./_components/composed/sections/ProtectBusinessSection/index.jsx





var ProtectBusinessSection_colors = theme/* theme.colors */.r.colors,
    ProtectBusinessSection_devices = theme/* theme.devices */.r.devices,
    ProtectBusinessSection_fontSizes = theme/* theme.fontSizes */.r.fontSizes,
    ProtectBusinessSection_spaces = theme/* theme.spaces */.r.spaces;

var ProtectBusinessSection_getConfig = config_default()(),
    ProtectBusinessSection_publicRuntimeConfig = ProtectBusinessSection_getConfig.publicRuntimeConfig;

var StyledProtectBusinessSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ProtectBusinessSection__StyledProtectBusinessSection",
  componentId: "sc-b9ok5n-0"
})(["max-width:", "px;width:100%;margin-top:", "px;margin-bottom:", "px;display:flex;flex-direction:column;.headerSection{font-family:'Aeonik';font-style:normal;font-weight:500;font-size:", "px;line-height:130%;text-align:center;color:", ";flex:none;order:0;align-self:stretch;flex-grow:0;}.columnDesktopContainer{display:flex;margin-top:", "px;justify-content:center;gap:30px;.description{font-size:", "px;line-height:150%;font-family:'Aeonik';font-style:normal;font-weight:400;text-align:center;color:", ";}}@media ", "{padding-left:", "px;padding-right:", "px;}@media ", "{margin-top:", "px;margin-bottom:", "px;margin-left:0;margin-right:0;padding:0px ", "px;display:flex;flex-direction:column;justify-content:center;align-items:center;gap:0px;flex:none;order:1;flex-grow:0;.headerSection{padding:0px ", "px;font-size:", "px;line-height:150%;}.columnDesktopContainer{flex-direction:column;width:100%;margin-top:", "px;.description{font-size:", "px;line-height:150%;font-family:'Aeonik';font-style:normal;font-weight:400;text-align:center;color:", ";width:100%;}}}"], ProtectBusinessSection_spaces.large24X * 10 + 80, ProtectBusinessSection_spaces.large24X, ProtectBusinessSection_spaces.large24X, ProtectBusinessSection_fontSizes.large11X, ProtectBusinessSection_colors.gray[800], ProtectBusinessSection_spaces.large7X - 2, ProtectBusinessSection_fontSizes.large, ProtectBusinessSection_colors.gray[800], ProtectBusinessSection_devices.laptopM, ProtectBusinessSection_spaces.large2X, ProtectBusinessSection_spaces.large2X, ProtectBusinessSection_devices.tablet, ProtectBusinessSection_spaces.large9X, ProtectBusinessSection_spaces.large9X, ProtectBusinessSection_spaces.regular, ProtectBusinessSection_spaces.regular, ProtectBusinessSection_fontSizes.large2X, ProtectBusinessSection_spaces.large2X, ProtectBusinessSection_fontSizes.large, ProtectBusinessSection_colors.gray[800]);
var StyledProduct = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ProtectBusinessSection__StyledProduct",
  componentId: "sc-b9ok5n-1"
})(["width:33.33%;display:flex;flex-direction:column;justify-content:center;align-items:center;padding:30px;gap:20px;background:", ";border-radius:16px;img{width:80px;}.container .description{margin-top:", "px;}@media ", "{img{width:", "px;}}@media ", "{padding:16px;flex-direction:row;width:initial;justify-content:space-between;img{width:60px;}}"], function (_ref) {
  var color = _ref.color;
  return color;
}, ProtectBusinessSection_spaces.small - 2, ProtectBusinessSection_devices.laptopM, ProtectBusinessSection_spaces.large24X, ProtectBusinessSection_devices.tablet);
var products = [{
  color: "".concat(ProtectBusinessSection_colors.blue[50]),
  description: 'Trademark Registration',
  icon: "".concat(ProtectBusinessSection_publicRuntimeConfig.basePath, "/images/clipboard.svg")
}, {
  color: "".concat(ProtectBusinessSection_colors.orange[50]),
  description: 'Trademark Alert Monitoring',
  icon: "".concat(ProtectBusinessSection_publicRuntimeConfig.basePath, "/images/bell-ring.svg")
}, {
  color: "".concat(ProtectBusinessSection_colors.green[50]),
  description: 'Trademark Renewals',
  icon: "".concat(ProtectBusinessSection_publicRuntimeConfig.basePath, "/images/favourite.svg")
}];

var ProtectBusinessSection = function ProtectBusinessSection() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledProtectBusinessSection, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "headerSection",
      children: "Protect Your Business with our Services"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "columnDesktopContainer",
      children: products.map(function (step, idx) {
        var color = step.color,
            description = step.description,
            icon = step.icon;
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledProduct, {
          color: color,
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("picture", {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("source", {
              srcSet: icon,
              type: "image/png"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
              src: icon,
              alt: ""
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "description",
            children: description
          })]
        }, "step:".concat(idx));
      })
    })]
  });
};

/* harmony default export */ var sections_ProtectBusinessSection = (ProtectBusinessSection);
// EXTERNAL MODULE: ./_components/composed/sections/TrustPilotSection/index.jsx + 2 modules
var TrustPilotSection = __webpack_require__(2238);
;// CONCATENATED MODULE: ./_components/composed/pages/HomePage/index.jsx


var _excluded = ["size", "rotate", "top", "bottom", "left", "right"],
    _excluded2 = ["top", "bottom", "left", "right"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






















var HomePage_devices = theme/* theme.devices */.r.devices;

var HomePage_getConfig = config_default()(),
    HomePage_publicRuntimeConfig = HomePage_getConfig.publicRuntimeConfig;

var StyledHomePage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "HomePage__StyledHomePage",
  componentId: "sc-z68svg-0"
})(["position:relative;display:flex;flex-direction:column;align-items:center;@media ", "{display:block;}"], HomePage_devices.tablet); // eslint-disable-next-line prettier/prettier, react/display-name

var StyledCircle = (0,styled_components_browser_esm/* default */.ZP)( /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var size = _ref.size,
      rotate = _ref.rotate,
      top = _ref.top,
      bottom = _ref.bottom,
      left = _ref.left,
      right = _ref.right,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", _objectSpread({
    ref: ref
  }, props));
})).withConfig({
  displayName: "HomePage__StyledCircle",
  componentId: "sc-z68svg-1"
})(["position:absolute;background:", ";border-radius:50%;opacity:0.1;z-index:-1;", " ", " ", " ", " ", " ", " @media ", "{display:none;}"], "linear-gradient(180deg, ".concat(theme/* theme.colors.blue.500 */.r.colors.blue[500], " 0%, rgba(46, 144, 250, 0) 100%)"), function (_ref2) {
  var top = _ref2.top;
  return typeof top !== 'undefined' && (0,styled_components_browser_esm/* css */.iv)(["top:", ";"], typeof top === 'string' ? top : "".concat(top, "px"));
}, function (_ref3) {
  var bottom = _ref3.bottom;
  return typeof bottom !== 'undefined' && (0,styled_components_browser_esm/* css */.iv)(["bottom:", ";"], typeof bottom === 'string' ? bottom : "".concat(bottom, "px"));
}, function (_ref4) {
  var left = _ref4.left;
  return typeof left !== 'undefined' && (0,styled_components_browser_esm/* css */.iv)(["left:", ";"], typeof left === 'string' ? left : "".concat(left, "px"));
}, function (_ref5) {
  var right = _ref5.right;
  return typeof right !== 'undefined' && (0,styled_components_browser_esm/* css */.iv)(["right:", ";"], typeof right === 'string' ? right : "".concat(right, "px"));
}, function (_ref6) {
  var rotate = _ref6.rotate;
  return rotate && (0,styled_components_browser_esm/* css */.iv)(["transform:", ";"], "rotate(".concat(rotate, "deg)"));
}, function (_ref7) {
  var size = _ref7.size;
  return size && (0,styled_components_browser_esm/* css */.iv)(["width:", "px;height:", "px;"], size, size);
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.devices.tablet;
}); // eslint-disable-next-line prettier/prettier, react/display-name

var StyledImageContainer = (0,styled_components_browser_esm/* default */.ZP)( /*#__PURE__*/(0,react.forwardRef)(function (_ref9, ref) {
  var top = _ref9.top,
      bottom = _ref9.bottom,
      left = _ref9.left,
      right = _ref9.right,
      props = (0,objectWithoutProperties/* default */.Z)(_ref9, _excluded2);

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", _objectSpread({
    ref: ref
  }, props));
})).withConfig({
  displayName: "HomePage__StyledImageContainer",
  componentId: "sc-z68svg-2"
})(["position:absolute;z-index:-1;", " ", " ", " ", " @media ", "{display:none;}"], function (_ref10) {
  var top = _ref10.top;
  return typeof top !== 'undefined' && (0,styled_components_browser_esm/* css */.iv)(["top:", ";"], typeof top === 'string' ? top : "".concat(top, "px"));
}, function (_ref11) {
  var bottom = _ref11.bottom;
  return typeof bottom !== 'undefined' && (0,styled_components_browser_esm/* css */.iv)(["bottom:", ";"], typeof bottom === 'string' ? bottom : "".concat(bottom, "px"));
}, function (_ref12) {
  var left = _ref12.left;
  return typeof left !== 'undefined' && (0,styled_components_browser_esm/* css */.iv)(["left:", ";"], typeof left === 'string' ? left : "".concat(left, "px"));
}, function (_ref13) {
  var right = _ref13.right;
  return typeof right !== 'undefined' && (0,styled_components_browser_esm/* css */.iv)(["right:", ";"], typeof right === 'string' ? right : "".concat(right, "px"));
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.devices.tablet;
});

var HomePage = function HomePage() {
  var dispatch = (0,es/* useDispatch */.I0)();
  var search = (0,es/* useSelector */.v9)(selector/* selectSearch */.CG);
  var handleChangeSearch = (0,react.useCallback)(function (search) {
    dispatch((0,slice/* refreshSearch */.Xm)(search));
  }, [dispatch]);
  var handleChangePage = (0,react.useCallback)(function (page) {
    dispatch((0,slice/* refreshPage */.ZM)(page));
  }, [dispatch]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledHomePage, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(sections_HomeBannerSection, {
      search: search,
      setSearch: handleChangeSearch,
      setPage: handleChangePage
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ThreeStepSection/* default */.Z, {
      title: "3 Step Process",
      subTitle: "Get your registered trademark in 3 easy steps.",
      steps: [{
        header: 'Search for Availability',
        description: 'Check to see if your trademark is already being used.',
        icon: "".concat(HomePage_publicRuntimeConfig.basePath, "/images/file-searching.svg")
      }, {
        header: 'Answer a few Questions',
        description: 'Fill out our simple questionnaire to begin the registration process.',
        icon: "".concat(HomePage_publicRuntimeConfig.basePath, "/images/my-answers-home.svg")
      }, {
        header: 'Application Filing',
        description: 'Your application will be filed with the U.S. Patent and Trademark Office (USPTO)',
        icon: "".concat(HomePage_publicRuntimeConfig.basePath, "/images/app-development-home.svg")
      }]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(TrustPilotSection/* default */.Z, {
      title: "Customer Reviews & Testimonials",
      subTitle: "See why others are choosing Trademark Genius!"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(BottomBannerSection/* default */.Z, {
      header: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: "Ensure that competitors don't infringe on your most vital assets."
      }),
      footer: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: ["100% Satisfaction Guaranteed.", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
          suffix: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
            alias: icons/* ICONS_ALIASES.arrowRight */.F.arrowRight,
            color: theme/* theme.colors.blue.500 */.r.colors.blue[500]
          }),
          color: theme/* theme.colors.white */.r.colors.white,
          onClick: function onClick() {
            return router_default().push(routes/* ROUTES.trademarkRegistration */.Z.trademarkRegistration);
          },
          textColor: theme/* theme.colors.blue.500 */.r.colors.blue[500],
          hoverColor: theme/* theme.colors.white */.r.colors.white,
          hoverTextColor: theme/* theme.colors.blue.500 */.r.colors.blue[500],
          children: "Start Registering Now"
        })]
      }),
      imgSrc: "".concat(HomePage_publicRuntimeConfig.basePath, "/images/shield.svg"),
      imgTopDesktopPosition: "-100px"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(sections_ProtectBusinessSection, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(FAQSection/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(BottomBannerSection/* default */.Z, {
      header: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: "Don't wait, Protect Your Brand now"
      }),
      footer: /*#__PURE__*/(0,jsx_runtime.jsx)(Button/* default */.Z, {
        suffix: /*#__PURE__*/(0,jsx_runtime.jsx)(Icon/* default */.Z, {
          alias: icons/* ICONS_ALIASES.arrowRight */.F.arrowRight,
          color: theme/* theme.colors.blue.500 */.r.colors.blue[500]
        }),
        color: theme/* theme.colors.white */.r.colors.white,
        onClick: function onClick() {
          return router_default().push(routes/* ROUTES.trademarkRegistration */.Z.trademarkRegistration);
        },
        textColor: theme/* theme.colors.blue.500 */.r.colors.blue[500],
        hoverColor: theme/* theme.colors.white */.r.colors.white,
        hoverTextColor: theme/* theme.colors.blue.500 */.r.colors.blue[500],
        children: "Start Registering Now"
      }),
      imgSrc: "".concat(HomePage_publicRuntimeConfig.basePath, "/images/trademark-registration-bottom.svg"),
      imgTopDesktopPosition: "-130px",
      moreSpace: true,
      disclaimer: true
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledCircle, {
      size: 686,
      rotate: 90,
      left: -273,
      top: '43%'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledImageContainer, {
      left: 80,
      top: '55%',
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("picture", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("source", {
          srcSet: "".concat(HomePage_publicRuntimeConfig.basePath, "/images/dots.svg"),
          type: "image/svg"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: "".concat(HomePage_publicRuntimeConfig.basePath, "/images/dots.svg"),
          alt: ""
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledCircle, {
      size: 752,
      rotate: -180,
      right: -192,
      top: '67%'
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledCircle, {
      size: 876,
      rotate: 90,
      left: -230,
      bottom: 150
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyledImageContainer, {
      left: 80,
      bottom: 325,
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("picture", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("source", {
          srcSet: "".concat(HomePage_publicRuntimeConfig.basePath, "/images/dots.svg"),
          type: "image/svg"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: "".concat(HomePage_publicRuntimeConfig.basePath, "/images/dots.svg"),
          alt: ""
        })]
      })
    })]
  });
};

/* harmony default export */ var pages_HomePage = (HomePage);
;// CONCATENATED MODULE: ./pages/index.js


function Home() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(pages_HomePage, {});
}

/***/ }),

/***/ 5557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(4235);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9460,9707,3346,2336,3981,9774,2888,179], function() { return __webpack_exec__(5557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);